import { Flex } from 'antd';
import { FC } from 'react';

import { Button, ButtonVariant } from '@/shared/ui/Button';
import { Modal } from '@/shared/ui/Modal';
import { Typography } from '@/shared/ui/Typography';

import { useDeleteUserRequest } from '@/pages/UserAccount/UserRequests/model';

import { UserRequest } from '@/api/types';

interface Props {
  draftIdToDelete: UserRequest['id'];
  isModalOpen: boolean;
  closeModal: () => void;
}

export const ConfirmDeleteUserRequestModal: FC<Props> = ({ draftIdToDelete, isModalOpen, closeModal }) => {
  const { mutate: deleteRequest, isPending } = useDeleteUserRequest();

  return (
    <Modal
      open={isModalOpen}
      size="md"
      centered
      title="Ви видаляєте активний запит"
      onCancel={closeModal}
      footer={
        <Flex gap={12}>
          <Button onClick={closeModal}>Не видаляти</Button>
          <Button
            variant={ButtonVariant.SECONDARY}
            disabled={isPending}
            onClick={(): void => {
              deleteRequest(draftIdToDelete, { onSuccess: closeModal });
            }}
          >
            <Typography color="red">Видалити запит</Typography>
          </Button>
        </Flex>
      }
    >
      <Typography color="graphite">Запит буде видалено назавжди. Ви впевнені, що хочете видалити цей запит?</Typography>
    </Modal>
  );
};
